<template>
    <div>
        <header-section
            title="Discount Rate Comparison"
            set-position="relative"
            :create-button="true"
            set-width="100">
        </header-section>
        <div class="o-content ie p-discount-rate-comparison">
            <div v-if="!processing">
                <page-form></page-form>

                <br /><hr /><br />

                <claims-preview v-if="preview.data.length"></claims-preview>

                <div v-else>
                    No matching claims match your search criteria. Please update your 
                    search criteria and perform another preview.
                </div>
            </div>
            <div v-else>
                <h2 class="u-padding-b-30">
                    Processing Discount Rates
                </h2>
                <p>
                    Your discount rates are currently being processed<br/><br/>
                    {{ progress.numberCompleted }} claims have been updated out of {{ progress.numberOfClaims }} <br/><br/>
                    Please check back soon.
                </p>
                <progress-bar :value="progress.numberCompleted" :total-value="progress.numberOfClaims"></progress-bar>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import PageForm from './components/update/PageForm';
    import ClaimsPreview from './components/update/ClaimsPreview';
    import HeaderSection from 'components/Header.vue';
    import ProgressBar from 'components/ProgressBar';

    export default {
        name: 'update-discount-rate',
        components: {
            PageForm,
            ClaimsPreview,
            HeaderSection,
            ProgressBar
        },
        mounted() {
            this.reset();
            this.checkProgress();
        },
        beforeDestroy() {
            this.cancelChecking();
        },
        computed: mapState('discountRateComparison', [
            'preview',
            'processing',
            'progress'
        ]),
        methods: mapActions('discountRateComparison', [
            'reset',
            'clearError',
            'checkProgress',
            'cancelChecking'
        ]),
    }
</script>



// WEBPACK FOOTER //
// UpdateDiscountRate.vue?29f374b6